import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
	Select,
	FormLabel,
} from '@chakra-ui/react'
import { InputText, Form } from '../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../helpers';
import { Field } from 'formik';

function Edit({ meCloseEdit, loadList, rs }) {

	const [roles, setRoles] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	const [formData, setFormData] = useState({
		username: rs.username,
		email: rs.email,
		id: rs.id,
		role_id: rs.role_id || '',
		data_access: rs.data_access || '',
	});

	useEffect(() => {
		const loadRoles = async () => {
			try {
				const url = `${process.env.REACT_APP_API_URL}/roles/list`;
				const res = await fetchWrapper.get(url);
				setRoles(res?.data || []);
				setIsLoading(false); // Set loading to false after roles are loaded
			} catch (err) {
				console.error(err);
				toast("Failed to load roles", { type: "error" });
				setIsLoading(false);
			}
		};
		loadRoles();
	}, []);

	const FormSchema = Yup.object().shape({
		username: Yup.string().required('Required'),
		email: Yup.string().required('Required'),
		role_id: Yup.string().required('Role is required'), // Add validation
	});

	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {
		let data = values

		const url = `${process.env.REACT_APP_API_URL}/user/update`;
		await fetchWrapper.post(url, data)
		loadList()
		meCloseEdit();
		toast(`Record has been updated`, {
			type: "info"
		});
	}

	// Don't render form until roles are loaded
	if (isLoading) {
		return <Box>Loading...</Box>;
	}

	return (
	
			<Form
				enableReinitialize
				validationSchema={FormSchema}
				initialValues={formData}
				onSubmit={onSubmit}
			>
				<Box mb="10px">
					<InputText name="username" title="Full Name" />
				</Box>
				<Box mb="10px">
					<InputText name="email" title="Email" />
				</Box>

				<Box mb="10px">
					<FormLabel fontSize="14px" mb="4px">Role</FormLabel>
					<Field name="role_id">
						{({ field }) => (
							<Select {...field} placeholder="Select Role">
								{roles.map((role) => (
									<option key={role.id} value={role.id}>
										{role.name}
									</option>
								))}
							</Select>
						)}
					</Field>
				</Box>

				<Box mb="10px">
					<FormLabel fontSize="14px" mb="4px">Data Access</FormLabel>
					<Field name="data_access">
						{({ field }) => (
							<Select {...field} placeholder="Select Data Access">
								<option value="A">All</option>
								<option value="O">Own</option>
							</Select>
						)}
					</Field>
				</Box>

				<Button 
					className='custom-chakra-button' 
					py="10px" 
					px="25px" 
					color="#fff" 
					bg="var(--brand-primary)" 
					fontSize="14px" 
					fontWeight="500" 
					fontFamily="'Lato', sans-serif"
					mb={4}
					type='submit'
				>
					Update User
				</Button>
			</Form>
		
	)
}

export default Edit;